/**
 * Keräilykortti PDP sticky ATC — mobile ≤749px.
 * Fallback IntersectionObserver: Horizon sticky may never set data-stuck
 * if product-form lookup fails; we observe buy-buttons-block directly.
 */
(function () {
  if (typeof document === 'undefined') return;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function init() {
    var mq = window.matchMedia('(max-width: 749px)');
    var sticky = document.querySelector('sticky-add-to-cart');
    if (!sticky) return;
    var bar = sticky.querySelector('.sticky-add-to-cart__bar');
    if (!bar) return;

    var target =
      document.querySelector('.buy-buttons-block') ||
      document.querySelector('product-form-component') ||
      document.querySelector('button[name="add"]') ||
      document.querySelector('.add-to-cart-button');

    function setStuck(stuck) {
      if (!mq.matches) {
        bar.setAttribute('data-stuck', 'false');
        document.documentElement.classList.remove('kk-sticky-atc-visible');
        document.documentElement.style.removeProperty('--kk-sticky-atc-pad');
        return;
      }
      bar.setAttribute('data-stuck', stuck ? 'true' : 'false');
      document.documentElement.classList.toggle('kk-sticky-atc-visible', !!stuck);
      if (stuck) {
        document.documentElement.style.setProperty(
          '--kk-sticky-atc-pad',
          'calc(72px + env(safe-area-inset-bottom, 0px))'
        );
      } else {
        document.documentElement.style.removeProperty('--kk-sticky-atc-pad');
      }
    }

    if (!target) {
      // Retry once after late hydration
      setTimeout(init, 800);
      return;
    }

    if (typeof IntersectionObserver === 'undefined') return;

    var io = new IntersectionObserver(
      function (entries) {
        var visible = entries.some(function (e) {
          return e.isIntersecting && e.intersectionRatio > 0;
        });
        setStuck(!visible);
      },
      { root: null, threshold: 0, rootMargin: '0px 0px 0px 0px' }
    );
    io.observe(target);

    if (mq.addEventListener) mq.addEventListener('change', function () { setStuck(bar.getAttribute('data-stuck') === 'true'); });
    else if (mq.addListener) mq.addListener(function () { setStuck(bar.getAttribute('data-stuck') === 'true'); });
  });
})();
